module.exports = __webpack_public_path__ + "static/img/engagement-tortoise.bdf38f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/engagement-tortoise.png
// module id = 46
// module chunks = 0